import { ReactNode } from "react";
import { Links } from "../../../content";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setMode } from "../../../store/reducers/document-metadata";
import { selectAuth, selectMetadata } from "../../../store/selectors";
import { INavLink } from "../../interfaces/Link";
import { HeaderMolecule } from "../../molecules/header";

interface Props {
  subNav?: ReactNode;
}

export function OverheidHeaderOrganism(props: Readonly<Props>) {
  const stateMeta = useAppSelector(selectMetadata);
  const dispatch = useAppDispatch();

  const links: INavLink[] = [
    {
      ...Links.intern.start,
      selected: window.location.hash.startsWith(Links.intern.start.href) || window.location.hash === "",
      authorized: false,
    },
    {
      ...Links.intern.documentenlijst,
      selected:
        window.location.hash.startsWith(Links.intern.documentenlijst.href) ||
        (window.location.hash.startsWith(Links.intern.aanleveren.href) && stateMeta.mode === "update"),
      authorized: true,
    },
    {
      ...Links.intern.aanleveren,
      selected: window.location.hash.startsWith(Links.intern.aanleveren.href) && stateMeta.mode !== "update",
      authorized: true,
      onClick: function () {
        dispatch(setMode("create"));
        if (window.location.hash.startsWith(Links.intern.aanleveren.href)) return;
      },
    },
    {
      ...Links.intern.over,
      authorized: false,
      selected: window.location.hash.startsWith(Links.intern.over.href),
    },
    {
      ...Links.intern.apidocs,
      authorized: false,
      selected: window.location.hash.startsWith(Links.intern.apidocs.href),
    },
  ];

  const state = useAppSelector(selectAuth);
  const navlinks = state.isAuthenticated ? links : links.filter((link: INavLink) => link.authorized === false);

  return (
    <HeaderMolecule
      logo="/assets/images/overheid-logo.svg"
      subtitle="Open overheid"
      links={navlinks}
      subNav={props.subNav}
    />
  );
}
